import Logo from './images/ijohs.png';
export let SERVER_URL = "https://ijohs.novareader.co/";
export const APP_NAME="IJOHS";
export const LOGO=Logo;


